var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ConfirmDialog',{attrs:{"group":_vm.id}}),_vm._v(" "),_c('button',{staticClass:"btn bg-red text-white py-2",on:{"click":function($event){return _vm.del()}}},[_c('i',{staticClass:"fas fa-trash"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }